<div class="main-container lg-view" *ngIf="!isLoading">
	<h3>Thread</h3>

	<div class="main-form">

		<div class="empty-message-container" *ngIf="!comments?.length">There are no items yet!</div>

		<ng-container *ngIf="comments.length">
			<div class="note-container" [class.message-tip-left]="!note.isPostedByCurrentUser"
				[class.message-tip-right]="note.isPostedByCurrentUser" *ngFor="let note of comments">
				<p class="note-subject" *ngIf="note.subject"><span>{{ note.subject }}</span></p>
				<p class="note-description" *ngIf="note.description"><span>{{ note.description }}</span></p>
				<p class="note-metadata">
					<span class="note-metadata-author" *ngIf="note.createdBy">by {{ note.createdBy }}</span>
					<span class="note-metadata-date">on
						{{ moment.parseZone(note.createdOn).format('MM/DD/YYYY hh:mm A') }}</span>
				</p>
			</div>
		</ng-container>
	</div>
</div>

<div class="actions-container  md-view" *ngIf="!isLoading">
	<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'"></action-button>
	<action-button [icon]="ButtonIcons.Comment" *ngIf="pageType === PageType.Customer" [name]="'Post to\nBoard'"
		[clickAction]="modal.open.bind(modal)"></action-button>
	<action-button [icon]="ButtonIcons.Comment" *ngIf="pageType === PageType.BoardMember" [name]="'Post\nNote'"
		[clickAction]="modal.open.bind(modal)"></action-button>
</div>

<generic-modal #modal>
	<ng-template #modalHeading>
		Note
	</ng-template>
	<ng-template #modalBody>
		<div class="brief-form-container">
			<form [formGroup]="formModel">
				<mat-form-field [floatLabel]="'always'">
					<textarea matInput formControlName="comment" rows="4"></textarea>
				</mat-form-field>
			</form>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-raised-button type="button" class="primary" (click)="addComment(); modal.hide()"
			[disabled]="formModel.invalid">Submit</button>
		<button mat-raised-button class="secondary" type="button" (click)="modal.hide()">Cancel</button>
	</ng-template>
</generic-modal>